// Sentry integration — currently a no-op (DSN not configured).
// If needed later, install `@sentry/react` and un-stub these functions.
let inited = false;

export async function initSentry() {
  // No-op: Sentry disabled in this build. To enable:
  // 1) yarn add @sentry/react
  // 2) set REACT_APP_SENTRY_DSN in frontend/.env
  // 3) restore dynamic import logic from git history.
  if (inited) return;
  if (!process.env.REACT_APP_SENTRY_DSN) return;
  inited = true;
}

export async function captureException(_err, _context) {
  // No-op stub.
}
